var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowOrderUpDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeLinecap: "round",
    width: 14,
    height: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M3 7l4 4 4-4M3 5l4-4 4 4"
  })));
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiID8+CjxzdmcKICBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgd2lkdGg9IjE0cHgiCiAgaGVpZ2h0PSIxMnB4IgogIHZpZXdCb3g9IjAgMCAxNCAxMiIKICB2ZXJzaW9uPSIxLjEiCiAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIgo+CiAgICA8cG9seWxpbmUgaWQ9ImhlYWQiIHBvaW50cz0iMyA3IDcgMTEgMTEgNyIgZmlsbD0iZ3JleSIgLz4KICAgIDxwb2x5bGluZSBpZD0iUGF0aCIgcG9pbnRzPSIzIDUgNyAxIDExIDUiIGZpbGw9ImdyZXkiIC8+Cjwvc3ZnPgo=";
export { SvgArrowOrderUpDown as ReactComponent };